import React from "react";
import PropTypes from "prop-types";
import BaseFieldComponent from "../BaseFieldComponent";
import SelectChipContainer from "../../../../connectui/component/input/SelectChipContainer";
import {buildStyles} from "connectui/component/buildStyles";
import Text from "connectui/component/display/Text";
import {getDefaultFieldLabel} from "../../../../utilities/helperFunctions";

const styles = (theme) => ({
  selectContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
});

const GuestGroupIdField = ({
  fieldData,
  handleValueChange,
  reducer,
  ...props
}) => {
  const classes = buildStyles(styles);
  const groups = reducer.listing_groups;
  const groupsDict = reducer.listing_groups_dict;
  const options = (
    props.type === "filter"
      ? [...groups.filter((g) => g.group_id !== "ALL")]
      : [
          {group_id: null, name: "None"},
          ...groups.filter((g) => g.group_id !== "ALL"),
        ]
  ).map((group) => group?.group_id);

  const handleInputChange = (newSelection) => {
    handleValueChange(
      fieldData.type,
      Array.isArray(newSelection)
        ? newSelection.filter((f) => f !== "")
        : newSelection,
    );
  };

  const handleFilterChange = (newSelection) => {
    handleValueChange(
      "custom",
      !!newSelection.length
        ? [{path: fieldData.field, value: newSelection}]
        : [],
    );
  };
  const renderInput = (isFilter) => (
    <div className={classes.selectContainer}>
      <SelectChipContainer
        options={options}
        selectedOptions={fieldData.val}
        onChange={(newSelection) =>
          isFilter
            ? handleFilterChange(newSelection)
            : handleInputChange(newSelection)
        }
        multiSelect={fieldData?.operator !== "is_not"}
        customRender={(option) => {
          const group = groupsDict[option];
          const isSelected = fieldData?.val?.includes(option);
          return (
            <Text
              variant="textSM"
              weight="medium"
              color={isSelected ? "blue700" : "gray700"}
            >
              {option === null ? "None" : group?.name}
            </Text>
          );
        }}
      />
    </div>
  );

  const getLabel = () => {
    if (Array.isArray(fieldData?.val)) {
      const groupNames = fieldData?.val?.map(
        (id) => groupsDict[id]?.name ?? "",
      );
      return getDefaultFieldLabel(groupNames);
    }

    //TODO pls fix the filters menu at some point to pass the fielddata as an ARRAY not two single values ty ty :)
    return groupsDict[fieldData?.val]?.name ?? "";
  };

  const getOperators = () => [
    "contains",
    "not_contains",
    "exists",
    "not_exists",
    "is_one_of",
  ];

  return (
    <BaseFieldComponent
      renderInput={() => renderInput()}
      renderFilter={() => renderInput(true)}
      getLabel={getLabel}
      getOperators={getOperators}
      {...props}
    />
  );
};

GuestGroupIdField.propTypes = {
  fieldData: PropTypes.object.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  reducer: PropTypes.object.isRequired,
};

export default GuestGroupIdField;
